export default __webpack_public_path__ + "128d5146959c4498c77740d7d0188e28.svg";